import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 案件管理相关接口 ******************* */

var apis = {
  // 保存排期
  save: {
    url: '/schedule/save',
    method: 'post'
  },
  // 修改排期
  update: {
    url: '/schedule/update',
    method: 'post'
  },
  // 删除排期
  delete: {
    url: '/schedule/delete',
    method: 'post'
  },
  // 排期详情
  scheduleById: {
    url: '/schedule/scheduleById',
    method: 'post'
  },
  // 获取该部门下人员
  newUserList: {
    url: '/dept/userList',
    method: 'get'
  },
  // 获取全部排期
  allSchedule: {
    url: '/schedule/allSchedule',
    method: 'post'
  },
  // 删除已排期的案件
  deleteScheduleAndCase: {
    url: '/schedule/deleteScheduleAndCase',
    method: 'post'
  },
  // 获取案件当事人
  getPersonInfos: {
    url: '/case/getPersonInfos',
    method: 'post'
  },
  // 获取案件当事人(2.0.1版本接口)
  getInPersonInfos: {
    url: '/case/getInPersonInfos',
    method: 'post'
  }
};
export default withHttp(apis, baseURL);